import React from "react";
import MemorableMomentsSC from "./memorable_moments.styles";
import JainGraduation from "../../../assets/jain_graduation.jpeg";
import Talk1 from '../../../assets/moments/talk_1.jpeg'
import Talk2 from '../../../assets/moments/talk_2.jpeg'
import Event1 from '../../../assets/moments/event_1.jpg'
import Misc1 from '../../../assets/moments/misc_1.jpg'
import Event2 from '../../../assets/moments/event_2.jpg'
import Guest1 from '../../../assets/moments/guest_1.jpg'
import Talk4 from '../../../assets/moments/talk_4.jpg'
import Talk5 from '../../../assets/moments/talk_5.jpg'
import Talk6 from '../../../assets/moments/talk_6.jpeg'
import Event3 from '../../../assets/moments/event_3.jpg'
import Kar1 from '../../../assets/moments/kar_1.jpg'
import Kar2 from '../../../assets/moments/kar_2.jpg'
import Award1 from '../../../assets/moments/award_1.jpg'
import Guest2 from '../../../assets/moments/guest_2.png'

// import Article1 from '../../../assets/moments/article_1.jpeg'
// import Article2 from '../../../assets/moments/article_2.jpeg'
// {
//         image: Article1,
//         incrHeight: true
//     },
//     {
//         image: Article2,
//         incrHeight: true
//     },

const items = [
    {
        image: JainGraduation,
    },
    {
        image: Talk6
    },
    {
        image: Talk1
    },
    {
        image: Guest2
    },
    {
        image: Event1
    },
    {
        image: Misc1
    },
    {
        image: Event2
    },
    {
        image: Guest1
    },
    {
        image: Talk4
    },
    {
        image: Talk5
    },
    {
        image: Talk2,
    },
    {
        image: Event3
    },
    {
        image: Kar1
    },
    {
        image: Kar2
    },
    {
        image: Award1
    }
];


const MemorableMoments = ({ ref }) => {
    return <MemorableMomentsSC>
        <h2 className="membership-title" ref={ref}>MEMORABLE MOMENTS</h2>

        <div className="membership-grid">
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    <div
                        className={`image-card ${item.incrHeight ? "incr_height" : ""}`}
                        style={{ backgroundImage: `url(${item.image})` }}
                    />
                </React.Fragment>
            ))}
        </div>
    </MemorableMomentsSC>
};

export default MemorableMoments;